import React, { useContext, useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import dataR from '../../data/cidr6.json';

const DuplicateClusterSizeHistogram = () => {
    //6_duplicate_cluster_sizes

    const data = dataR.map(item => item.Record_Count);
    if (data.length === 0) return <div>Loading chart...</div>;

    // Histogram binning
    const binCount = 20;
    const max = Math.max(...data);
    const binSize = Math.ceil(max / binCount);
    const bins = new Array(binCount).fill(0);

    data.forEach(count => {
        const index = Math.min(Math.floor(count / binSize), binCount - 1);
        bins[index]++;
    });

    const xLabels = bins.map((_, i) => {
        const start = i * binSize;
        const end = start + binSize - 1;
        return `${start}-${end}`;
    });

    const option = {
        title: {
            text: 'Distribution of Cluster Sizes (Original)',
            left: 'center',
            textStyle: {
                fontSize: window.innerWidth <= 668 ? 12 : 18,
                overflow: 'truncate', // or use 'break' if wrapping manually
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: ({ 0: { name, value } }) => `Cluster Size: ${name}<br/>Count: ${value}`,
        },
        xAxis: {
            type: 'category',
            data: xLabels,
            name: 'Number of Records in Cluster',
            axisLabel: {
                rotate: 45,
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            },
            nameLocation: 'middle',
            nameGap: 60,
        },
        yAxis: {
            type: 'value',
            name: 'Count',
            axisLabel: {
                color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
            }
        },
        grid: {
            left: '2%',
            right: '10%',
            bottom: '15%',
            top: '15%',
            containLabel: true,
        },
        series: [
            {
                type: 'bar',
                data: bins,
                itemStyle: {
                    color: '#6366f1', // Indigo-500
                },
            },
        ],
    };

    return (
        <div className="border-2 border-gray-300 rounded-lg p-4 bg-white dark:bg-black shadow">
            <ReactECharts option={option} style={{ height: 400 }} />
        </div>
    );
};

export default DuplicateClusterSizeHistogram;
